import React from 'react';
import { useTranslation } from '../../i18next';
import { Centered } from '../../layout/Centered';

export const NotFound = ({ height }: { height?: number }) => {
  const { t } = useTranslation();
  return <Centered height={height}>{t('NotFound')}</Centered>;
};
